import React from 'react';
import { useSelector } from 'react-redux';
import { getOneCmsLoungeFinderImagesBaseUrl } from '@/selectors/oneCmsSelectors';
import { getLastViewedProduct } from '@/selectors/lastViewedProductSelectors';
import { cn } from '@/helpers/utils';
import LFLink from './LFLink';
import { IconCity } from '../icons';

const AirportLinkWithImage = ({ background, airport, ...restofProps }) => {
  const lastViewedProduct = useSelector(getLastViewedProduct);
  const cmsImgBaseUrl = useSelector(getOneCmsLoungeFinderImagesBaseUrl);

  const { iata, image, name, city } = airport;
  const { position } = restofProps;
  const urlAirportIata = iata ? `/${iata}` : '';
  const airportImageUrl =
    image && `${cmsImgBaseUrl}${image.replace(/^\//, '')}`;

  return (
    <LFLink
      key={`featured-airports-link-${iata}`}
      element={`header>>Find a City or Airport>>Popular Airports>>position ${position}>>${iata}`}
      className={cn('tw-inline-flex tw-min-w-0 tw-items-center tw-font-dls', {
        'tw-max-w-full': background === 'dark',
        'tw-max-w-80': background !== 'dark',
      })}
      to={`${lastViewedProduct}${urlAirportIata}/`}
      onClickHandler={restofProps?.onClickHandler}
    >
      {airportImageUrl ? (
        <img
          alt=""
          src={airportImageUrl}
          width="48"
          height="48"
          className="tw-h-12 tw-w-12 tw-shrink-0 tw-rounded-lg tw-bg-gray-300 tw-object-cover"
        />
      ) : (
        <IconCity className="tw-h-12 tw-w-12 tw-shrink-0" />
      )}
      <div className="tw-ml-4 tw-flex tw-min-w-0 tw-flex-col tw-justify-center">
        <span
          className={`tw-truncate tw-text-base ${
            background === 'dark' ? 'tw-text-gray-200' : 'tw-text-gray-800'
          }`}
        >
          {name}
        </span>
        <span
          className={`tw-text-xs ${
            background === 'dark' ? 'tw-text-gray-300' : 'tw-text-gray-700'
          }`}
        >
          {iata} • {airport.location ? airport.location.city : city}
        </span>
      </div>
    </LFLink>
  );
};

export default AirportLinkWithImage;
